//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import APIService from "@/services/APIService";

export default {
  name: "Manufacturers",
  data() {
    return {
      manufacturers: []
    }
  },
  methods: {
    showDetails( id ) {
      this.$router.push({ name: 'manufacturer', params: { id } })
    },

  },
  beforeRouteEnter(to, from, next) {
    console.log("Entered", to, from);
    APIService.getManufacturers( from.params['ID'] ).then(( manufacturers )  => {
      console.log( 'Manufacturers fetched', manufacturers )
      next(vm => {
        vm.manufacturers = manufacturers
      });
    })
  }
}
